import { useMutation, useQueryClient } from "@tanstack/react-query";
import scenarioRepository from "@/repository/scenarioRepository";
import { scenarioQueryKeys } from "./keys";


export const useCreateScenario = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['scenario', "create"],
        mutationFn: async ({ name, description }: { name: string; description: string }) => {
            const response = await scenarioRepository.create(name, description);
            return response.data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries({ queryKey: scenarioQueryKeys.pageAll() }),
                queryClient.refetchQueries({ queryKey: scenarioQueryKeys.recent() })
            ]);
        }
    });
};
